module.exports = __webpack_public_path__ + "static/media/NunitoSans-SemiBold.a87aa3a5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NunitoSans-SemiBold.ttf
// module id = 3139
// module chunks = 51